<template>
  <SwapOffer
    :buybackOffer="buybackOffer || null"
    :buybackOfferPayload
    :display-guidance="false"
    :model
    :zone
    @default-item-selected="$emit('default-item-selected')"
    @item-selected="(item) => $emit('item-selected', item)"
    @remove="$emit('remove')"
  />

  <div class="bg-surface-default-mid absolute bottom-0 left-0 right-0 m-24">
    <div class="flex space-x-2">
      <RevButton full-width="always" variant="primary" @click="$emit('close')">
        {{ closeWording }}
      </RevButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { GetOfferV1Response } from '@backmarket/nuxt-layer-buyback/app/scopes/offer/api/types'
import { RevButton } from '@ds/components/Button'

import SwapOffer from '../SwapOffer/SwapOffer.vue'

defineProps<{
  buybackOffer?: GetOfferV1Response
  buybackOfferPayload: Record<string, unknown> | null
  model: string
  zone: string
  closeWording: string
}>()

defineEmits(['close', 'remove', 'default-item-selected', 'item-selected'])
</script>
